<template>
    <div class="page-index">
        <div class="hd">
            <div class="info">
                <div class="info-hd">医院名称</div>
                <div class="info-bd">{{ hospitalName }}</div>
            </div>
            <div class="info-icon">
                <img class="info-icon-img" src="../../assets/info-icon.png" alt="">
            </div>
            <div class="bg"></div>
        </div>
        <div class="bd">
            <div class="box">
                <div class="box-hd">
                    <div class="box-hd-label">费用总额</div>
                    <div class="box-hd-value">{{ totalFee }}</div>
                </div>
                <div class="box-bd">
                    <div class="box-item">
                        <div class="box-bd-label">门诊类别</div>
                        <div class="box-bd-value">{{ payType }}</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">门诊科室</div>
                        <div class="box-bd-value">{{ dept }}</div>
                    </div>
                </div>
<!--                <div class="box-ft">-->
<!--                    <div class="box-ft-label">时间</div>-->
<!--                    <div class="box-ft-value">{{ createDate }}</div>-->
<!--                </div>-->
            </div>
            <div class="bd-append">
                <i class="bd-append-icon"></i>
                <div class="bd-append-text">医保退号</div>
            </div>
        </div>
        <div class="ft">
            <div class="btn" @click="pay">确定</div>
        </div>

    </div>
</template>

<script>

    import {getQueryString} from '../../utils/common'
    import {unRegistRecord, presettle, queryBillsInfo, verifyBill} from '../../api/Api'
    import {Toast} from 'vant'

    export default {
        name: 'PageIndex',
        data() {
            return {
                hospitalName: '伊犁哈萨克自治州友谊医院',
                payType: '',
                dept: '',
                doctor: '',
                createDate: '',
                totalFee: '',
                medOrgOrd: '',
                authCode: '',
                retCode: '',
                type: '',
            }
        },
        methods: {
            async queryBillsInfo() {
                Toast.loading({
                    message: '查询中...', duration: 0
                });
                let ret = await queryBillsInfo(this.medOrgOrd);
                Toast.clear();
                if (ret.status !== 200) {
                    Toast.fail("未查询到交易信息");
                    return;
                }
                console.log(ret);
                let prescription = ret.data.prescription;
                this.payType = prescription.payType;
                this.dept = prescription.dept;
                this.doctor = prescription.doctor;
                this.createDate = prescription.createDate;
                this.totalFee = prescription.totalFee;
            },
            async pay() {
                //验证处方信息,确保医生没有修改原处方
                Toast.loading({
                    message: '验证信息...', duration: 0
                });
                console.log("medOrgOrd", this.medOrgOrd)
                let billRet = await verifyBill(this.medOrgOrd);
                Toast.clear();
                if (billRet.status !== 200) {
                    Toast.fail(billRet.message);
                    return;
                }

                if(billRet.data == "0"){
                    //发起医保退号
                    Toast.loading({
                        message: '正在退号...', duration: 0
                    });
                    let p = {
                        merOrgOrd: this.medOrgOrd,
                        type: this.type
                    }
                    let ret = await unRegistRecord(p);
                    Toast.clear();
                    if (ret.status !== 200) {
                        Toast.fail(ret.message);
                        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbbbf21ec24a1b219&redirect_uri=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fwx%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_re";
                        return;
                    } else {
                        Toast.fail("退号成功");
                        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbbbf21ec24a1b219&redirect_uri=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fwx%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_re";
                        return;
                    }
                } else {
                    Toast.fail("验证失败,请于窗口办理");
                    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbbbf21ec24a1b219&redirect_uri=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fwx%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_re";
                    return;
                }
            },
            /**
             * 预结算
             */
            async doPreSettle(medOrgOrd, authCode) {
                Toast.loading({
                    message: '正在查询医保信息...', duration: 0
                });
                let ret = await presettle(medOrgOrd, authCode);
                Toast.clear();
                if (ret.status !== 200) {
                    Toast.fail(ret.message);
                    return;
                }
                if (ret.data.code !== "0000") {
                    Toast.fail(ret.data.message);
                    return;
                }
            }
        },
        mounted: function () {
            this.$nextTick(async function () {
                Toast.fail("saveToken" + this.$store.state.Authorization)
                window.document.title = "医保退号";
                this.medOrgOrd = getQueryString("medOrgOrd")
                this.authCode = getQueryString("authCode")
                this.retCode = getQueryString("retCode")
                this.type = getQueryString("type")
                if (this.retCode !== '0') {
                    Toast.fail("授权失败");
                    return;
                }
                await this.queryBillsInfo();
                await this.doPreSettle(this.medOrgOrd, this.authCode);
            })
        }
    }
</script>

<style scoped>
    @import '../../assets/index.css';
    @import '../../assets/actionsheet.css';
</style>
